import { TeamMenuSettings } from '../types/user';


export const getMetricColumnWidth = (metricName: string, hasIcon?: boolean) => {
  return Math.max(metricName.length * 7 + 10.5, 50) + 20 + (hasIcon ? 15 : 0);
};


// we want to add a small padding to the right of icon columns in playerSimpleTable (except role), if there is no other column to the right
const anyNumericColumnSelected = (menu: TeamMenuSettings) => menu.role_index || menu.skill_index || menu.age || menu.contract_expiration || menu.locality;
const anyIconColumnSelected = (menu: TeamMenuSettings) => menu.club_logo_url || menu.country_code || menu.form_status || menu.availability_status;
export const shouldAddPlayerSimpleTableTeamViewPadding = (menu: TeamMenuSettings) => anyIconColumnSelected(menu) && !anyNumericColumnSelected(menu);
